<form class="container" [formGroup] ="assistantForm">
    <div class="row mt-2 d-flex justify-content-end">
        <div class="col-6 p-0">
            <div class="slider-label-container">
                <label class="example-name-label">Voice Speed</label>
                <label>{{slider.value}}</label>
              </div>
            <mat-slider [min]="voiceSpeedRange.min"  [max]="voiceSpeedRange.max" step="0.05" style="width: 95%;">
                <input matSliderThumb  #slider formControlName="voiceSpeed">
              </mat-slider>
        </div>
    </div>
    <div class="row mt-2 d-flex justify-content-end">
        <div class="col-6 p-0">
            <div class="slider-label-container">
                <label class="example-name-label">Voice Stability</label>
                <label>{{slider1.value}}</label>
              </div>
            <mat-slider [min]="voiceStabilityRange.min" [max]="voiceStabilityRange.max" step="0.05" style="width: 95%;">
                <input matSliderThumb  #slider1 formControlName="voiceStability">
              </mat-slider>
        </div>
    </div>
    
    <div class="row mt-2 d-flex justify-content-end">
        <div class="col-6 p-0">
            <div class="slider-label-container">
                <label class="example-name-label">Voice Similarity</label>
                <label>{{slider2.value}}</label>
              </div>
            <mat-slider [min]="voiceSimilarityRange.min" [max]="voiceSimilarityRange.max" step="0.05" style="width: 95%;">
                <input matSliderThumb  #slider2 formControlName="voiceSimilarity">
              </mat-slider>
        </div>
    </div>
</form>
